// WHAT: Shared types and context for mock search
// WHY:  Keep React components in .tsx file only for fast-refresh rule

import { createContext } from "react";

export interface SearchItem {
  id: number;
  path: string;
  title: string;
  type: "app" | "page";
}

/**
 * Interface for search context value
 */
export interface SearchContextType {
  /** Function to clear search */
  clearSearch: () => void;
  /** Whether search panel is open */
  isSearchOpen: boolean;
  /** Function to perform search */
  performSearch: (query: string) => void;
  /** Current search query */
  searchQuery: string;
  /** Array of search results */
  searchResults: SearchItem[];
  /** Function to set search panel open state */
  setIsSearchOpen: (open: boolean) => void;
  /** Function to set search query */
  setSearchQuery: (query: string) => void;
  /** Function to set search results */
  setSearchResults: (results: SearchItem[]) => void;
}

export const SearchContext = createContext<SearchContextType | undefined>(undefined);
